module.exports = "../../app/cells/components/vertical_notice_cell.rb";